import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import AlertActions from '../Alert/AlertActions/index.esm.js';
import AlertBody from '../Alert/AlertBody/index.esm.js';
import AlertButton from '../Alert/AlertButton/index.esm.js';
import AlertDescription from '../Alert/AlertDescription/index.esm.js';
import AlertTitle from '../Alert/AlertTitle/index.esm.js';
import Alert from '../Alert/index.esm.js';
import { toast as toast$1, ToastContainer as ToastContainer$1, Zoom } from 'react-toastify';

var Toast = function Toast(props) {
  var id = props.id,
      onClose = props.onClose,
      title = props.title,
      description = props.description,
      _props$position = props.position,
      position = _props$position === void 0 ? 'top-center' : _props$position,
      onClick = props.onClick,
      actionHref = props.actionHref,
      actionTarget = props.actionTarget,
      actionLabel = props.actionLabel,
      rest = _objectWithoutPropertiesLoose(props, ["id", "onClose", "title", "description", "position", "onClick", "actionHref", "actionTarget", "actionLabel"]);

  return React__default.createElement(Alert, _extends({
    onClose: onClose,
    id: id,
    margin: [!position || position.includes('top') ? 'mt-4' : 'mb-4', 'mx-4'],
    boxShadow: "shadow-toast",
    borderWidth: "border-0",
    // react-toastify also declare a role of "alert" on the toast container
    // role is set empty here to prevent multiple roles from being set.
    // eslint-disable-next-line jsx-a11y/aria-role
    role: ""
  }, rest), React__default.createElement(AlertBody, null, title && React__default.createElement(AlertTitle, null, title), description && React__default.createElement(AlertDescription, {
    textColor: "text-gray-600"
  }, description)), (onClick || actionHref) && React__default.createElement(AlertActions, {
    space: "space-x-2"
  }, React__default.createElement(AlertButton, {
    primary: true,
    href: actionHref,
    target: actionTarget,
    onClick: onClick
  }, actionLabel)));
};

var isToastProps = function isToastProps(render) {
  return typeof render !== 'function';
};

var calculateAutoClose = function calculateAutoClose(render) {
  // If using a custom renderer, default to 5 seconds
  if (!isToastProps(render)) {
    return 5000;
  }

  var appearance = render.appearance,
      actionLabel = render.actionLabel,
      description = render.description,
      title = render.title; // Persist error toasts

  if (appearance === 'error') {
    return false;
  } // Calculate based on text content


  return [actionLabel, description, title].join(' ').length * 200;
};

var nativeNotify = function nativeNotify(render) {
  if (!window.Notification) {
    return;
  }

  var notification = null;

  if (!isToastProps(render)) {
    return;
  }

  var title = render.title,
      description = render.description;

  if (!title) {
    return;
  }

  var options = {
    body: description == null ? void 0 : description.toString(),
    vibrate: [200, 100, 200],
    renotify: true,
    tag: 'sajari-toast'
  };

  if (Notification.permission === 'granted') {
    // Let's check whether notification permissions have already been granted
    // If it's okay let's create a notification
    notification = new Notification(title, options);
  } else if (Notification.permission !== 'denied') {
    // Otherwise, we need to ask the user for permission
    Notification.requestPermission(function (permission) {
      // If the user accepts, let's create a notification
      if (permission === 'granted') {
        notification = new Notification(title, options);
      }
    });
  } // If notification was shown, make clicking it take you back to the window


  if (notification) {
    notification.onclick = function () {
      window.focus();
    };
  }
};

function toast(render, options) {
  var _ref = options != null ? options : {},
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'top-center' : _ref$position,
      _ref$autoClose = _ref.autoClose,
      autoClose = _ref$autoClose === void 0 ? calculateAutoClose(render) : _ref$autoClose,
      handleOnClose = _ref.onClose,
      _native = _ref["native"],
      _ref$closable = _ref.closable,
      closable = _ref$closable === void 0 ? true : _ref$closable,
      rest = _objectWithoutPropertiesLoose(_ref, ["position", "autoClose", "onClose", "native", "closable"]);

  if (_native) {
    nativeNotify(render);
  }

  var rtOptions = _extends({
    position: position,
    autoClose: autoClose,
    hideProgressBar: true,
    draggable: false
  }, rest);

  if (isToastProps(render)) {
    return toast$1(function (_ref2) {
      var toastProps = _ref2.toastProps;
      var closeToast = toastProps.closeToast,
          toastId = toastProps.toastId;
      return React__default.createElement(Toast, _extends({}, _extends({
        onClose: closable ? function () {
          closeToast == null ? void 0 : closeToast();

          if (handleOnClose) {
            handleOnClose(toastProps);
          }
        } : undefined,
        id: toastId.toString(),
        position: position
      }, render)));
    }, _extends({}, rtOptions));
  }

  return toast$1(render, rtOptions);
}
toast.loading = toast$1.loading;
toast.promise = toast$1.promise;
toast.dismiss = toast$1.dismiss;
toast.clearWaitingQueue = toast$1.clearWaitingQueue;
toast.isActive = toast$1.isActive;
toast.done = toast$1.done;
toast.onChange = toast$1.onChange;
toast.POSITION = toast$1.POSITION;
toast.TYPE = toast$1.TYPE;
var ToastContainer = function ToastContainer() {
  return React__default.createElement(ToastContainer$1, {
    newestOnTop: true,
    closeButton: false,
    bodyClassName: function bodyClassName() {
      return '';
    },
    closeOnClick: false,
    toastClassName: function toastClassName() {
      return 'mb-0 max-w-xl';
    },
    transition: Zoom
  });
};

export { ToastContainer, toast };
//# sourceMappingURL=index.esm.js.map
